/* Unauthenticated routes */
export const LOGIN = '/';
export const LOGIN_MFA = '/mfa/';

export const NOT_FOUND = '/404/';

export const FORGOT_PASSWORD = '/reset-password/';
export const FORGOT_PASSWORD_SUCCESS = '/reset-password/success/';
export const FORGOT_PASSWORD_SENT = '/reset-password/sent/';
export const FORGOT_PASSWORD_ERROR = '/reset-password/error/';
export const FORGOT_PASSWORD_RESET = '/reset-password/reset/';
export const FORGOT_PASSWORD_ERROR_EXPIRED = '/reset-password/error/expired';
export const FORGOT_PASSWORD_ERROR_INVALID = '/reset-password/error/invalid';
export const SETUP_MFA = '/setup-mfa/';

export const VERIFY_CODE = '/verify-code/';

export const COMPLETE_NEW_PASSWORD = '/complete-new-password/';
export const COMPLETE_NEW_PASSWORD_SUCCESS = '/complete-new-password/success/';
export const COMPLETE_NEW_PASSWORD_SENT = '/complete-new-password/sent/';
export const COMPLETE_NEW_PASSWORD_ERROR = '/complete-new-password/error/';
export const COMPLETE_NEW_PASSWORD_RESET = '/complete-new-password/reset/';
export const COMPLETE_NEW_PASSWORD_ERROR_EXPIRED =
  '/complete-new-password/error/expired';
export const COMPLETE_NEW_PASSWORD_ERROR_INVALID =
  '/complete-new-password/error/invalid';

export const EMERGENCY_ACCESS = '/emergency-access/';
export const SHARED = '/shared/';

/**
 * SSO handoff landing route. The backend mints this exact path (no trailing
 * slash) with the nonce in the fragment, so it has to keep matching
 * HANDOFF_ROUTE in engage-v2-backend's sso_handoff.service.ts.
 */
export const SSO_HANDOFF = '/sso/handoff';

export const MESSENGER = '/messenger/';

export const UNAUTHENTICATED_ROUTES = [
  LOGIN,
  LOGIN_MFA,
  SETUP_MFA,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_SENT,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_RESET,
  FORGOT_PASSWORD_ERROR_EXPIRED,
  FORGOT_PASSWORD_ERROR_INVALID,
  VERIFY_CODE,
  COMPLETE_NEW_PASSWORD,
  COMPLETE_NEW_PASSWORD_SUCCESS,
  COMPLETE_NEW_PASSWORD_SENT,
  COMPLETE_NEW_PASSWORD_ERROR,
  COMPLETE_NEW_PASSWORD_RESET,
  COMPLETE_NEW_PASSWORD_ERROR_EXPIRED,
  COMPLETE_NEW_PASSWORD_ERROR_INVALID,
  EMERGENCY_ACCESS,
  SHARED,
  SSO_HANDOFF,
];

export const DEVICE_INTEGRATOR_RETURN = '/device-integrator/return/';
export const CONTACTS = '/contacts/';
export const DASHBOARD = '/dashboard/';
export const DEVICES = '/devices/';
export const HEALTH_SUMMARY = '/summary/';
export const HEALTH_SUMMARY_PRINT = '/summary/print/';
export const CLIENTS = '/clients/';
export const PATIENTS = '/patients/';
export const TASKS = '/tasks/';
export const DISCERN = '/discern/';
export const DISCERN_JOBS = `${DISCERN}jobs/`;
export const DISCERN_JOBS_CURATE = (documentId: string) =>
  `${DISCERN_JOBS}${documentId}/curate`;
export const ACCOUNTS = '/accounts/';
export const INTEGRATIONS = '/integrations/';

/* Records */
export const ALLERGIES = '/records/allergies/';
export const APPOINTMENT_HISTORY = '/records/appointments/';
export const EMERGENCY_VISITS = '/records/emergency-visits/';
export const FAMILY_HISTORY = '/records/family-history/';
export const GENETIC_INFORMATION = '/records/genetic-information/';
export const HOSPITALIZATIONS = '/records/hospitalizations/';
export const IMAGING_TESTS = '/records/imaging-tests/';
export const IMMUNIZATIONS = '/records/immunizations/';
export const LAB_RESULTS = '/records/lab-results/';
export const LAB_RESULTS_REPORT = '/records/lab-results/report';
export const LAB_RESULTS_REPORT_DETAIL = '/records/lab-results/report/detail';
export const MEDICAL_CONDITIONS = '/records/medical-conditions/';
export const MEDICATIONS = '/records/medications/';
export const MEDICATIONS_PRINT = '/records/medications/print/';
export const RECORDS = '/records/';
export const SURGERIES = '/records/surgeries/';
export const VITAL_SIGNS = '/records/vital-signs/';
export const FITNESS = '/records/daily-stats/';
export const BODY = '/records/body/';
export const SLEEP = '/records/sleep/';
export const ACTIVITY = '/records/activity/';
export const HEALTH_SCORE = '/health-scores/';
export const BODY_SCAN = '/records/body-scan-history/';
export const FACE_SCAN = '/records/face-scan-history/';
export const COUGH_SCAN = '/records/cough-scan-history/';
export const SKIN_SCAN = '/records/skin-scan-history/';

/* Add Records */
export const ADD_APPOINTMENT = `${APPOINTMENT_HISTORY}add/`;
export const ADD_FAMILY_HISTORY = `${FAMILY_HISTORY}add/`;
export const ADD_IMMUNIZATION = `${IMMUNIZATIONS}add/`;
export const ADD_GENETIC_INFORMATION = `${GENETIC_INFORMATION}add/`;
export const ADD_MEDICATION = `${MEDICATIONS}add/`;

export const EDIT_CONTACT = '/contacts/edit/';

export const ROUTINES = '/routines/';

export const LEGAL = '/legal/';
export const BLOOD_PRODUCTS = `${LEGAL}blood-products/`;
export const HEROIC_MEASURES = `${LEGAL}heroic-measures/`;
export const LIVING_WILL = `${LEGAL}living-will/`;
export const ORGAN_DONATION = `${LEGAL}organ-donation/`;
export const ADD_INSURANCE = '/insurance/add/';
export const INSURANCE = '/insurance/';

export const MANAGE_ACCOUNT = '/user-profile/';

export const MANAGE_PROFILE = `${MANAGE_ACCOUNT}profile/`;
export const UPDATE_EMAIL = `${MANAGE_PROFILE}email/`;
export const UPDATE_NAME = `${MANAGE_PROFILE}name/`;
export const UPDATE_PASSWORD = `${MANAGE_PROFILE}password/`;
export const UPDATE_AVATAR = `${MANAGE_PROFILE}avatar/`;
export const UPDATE_MFA = `${MANAGE_PROFILE}mfa/`;
export const UPDATE_PHONE = `${MANAGE_PROFILE}phone/`;
export const GET_QR_CODE = `${MANAGE_PROFILE}qr-code/`;

// Org settings + management
export const ORG_MANAGEMENT = `/account-management/`;
export const ORG_PROFILE_SETTINGS = `${ORG_MANAGEMENT}profile/`;
export const ORG_MANAGE_ALERT_SETTINGS = `${ORG_MANAGEMENT}alerts/`;
export const ORG_MANAGE_DETAILS_NOTES = `${ORG_MANAGEMENT}details-and-notes/`;
export const ORG_MANAGE_LICENSE_PLAN = `${ORG_MANAGEMENT}license-plan/`;
export const ORG_MANAGE_USERS = `${ORG_MANAGEMENT}users/`;
export const ADD_ORG_USER = `${ORG_MANAGE_USERS}new-user/`;
export const ORG_BRAND_SETTINGS = `${ORG_MANAGEMENT}brand/`;

export const MANAGE_SUBSCRIPTION = `${MANAGE_ACCOUNT}payment-billing/`;
export const MANAGE_PAYMENT_DETAILS = `${MANAGE_SUBSCRIPTION}payment-details/`;
export const MANAGE_BILLING_ADDRESS = `${MANAGE_SUBSCRIPTION}billing-address/`;
export const MANAGE_INVOICES = `${MANAGE_SUBSCRIPTION}invoices/`;

export const MANAGE_CONSENTS = `${MANAGE_ACCOUNT}consents/`;
export const MANAGE_ACCESS_MANAGEMENT = `${MANAGE_ACCOUNT}access-management/`;
export const MANAGE_ACCESS_MANAGEMENT_INVITE = `${MANAGE_ACCESS_MANAGEMENT}invite/`;
export const MANAGE_NOTIFICATIONS = `${MANAGE_ACCOUNT}notifications/`;
export const MANAGE_ALERTS = `${MANAGE_ACCOUNT}alerts/`;
export const MANAGE_PLAN = `${MANAGE_ACCOUNT}plan/`;
export const MANAGE_SETTINGS = `${MANAGE_ACCOUNT}settings/`;
export const MANAGE_APPEARANCE = `${MANAGE_ACCOUNT}appearance/`;

export const EMERGENCY_ACCESS_SETTINGS = '/settings/emergency-access/';
export const SETTINGS = '/settings/';

export const APP_INFORMATION = '/app-information/';

export const TIMELINE = '/timeline/';

export const SEARCH = '/search/';

export const UPDATE = '/update';

export const DICOM_VIEWER = '/dicom/';

export const UPLOADS = '/uploads';

export const HOSPITAL_CONNECTIONS = '/emr-connections';

export const SHARE_HISTORY = '/share-history';

export const ALERTS = '/alerts/';
export const AUDIT_LOGS = '/audit-logs/';
export const ASSESSMENTS = '/assessments/';
export const ASSESSMENTS_DHA = `${ASSESSMENTS}dha/`;
export const ASSESSMENTS_OTHER = `${ASSESSMENTS}other/`;

// Very special route to direct the active user to the right dashboard ( admin dashboard or user dashboard )
export const LOADING = '/loading/';

// --------- admin --------- //
export const ADMIN_DASHBOARD = '/dashboard/';
export const ADMIN_MANAGEMENT = '/admin/';
export const ADMIN_MANAGE_USERS = `${ADMIN_MANAGEMENT}users/`;
export const ADMIN_MANAGE_USERS_CREATE = `${ADMIN_MANAGE_USERS}create/`;
export const ADMIN_MANAGE_ROLES = `${ADMIN_MANAGEMENT}roles/`;
export const ADMIN_MANAGE_ROLES_CREATE = `${ADMIN_MANAGE_ROLES}create/`;
export const ADMIN_MANAGE_OPERATIONS = `${ADMIN_MANAGEMENT}operations/`;
export const ADMIN_MANAGE_OPERATIONS_CREATE = `${ADMIN_MANAGE_OPERATIONS}create/`;
export const ADMIN_MANAGE_POLICIES = `${ADMIN_MANAGEMENT}policies/`;
export const ADMIN_MANAGE_POLICIES_CREATE = `${ADMIN_MANAGE_POLICIES}create/`;
export const ADMIN_MANAGE_PERMISSIONS = `${ADMIN_MANAGEMENT}permissions/`;
export const ADMIN_MANAGE_PERMISSIONS_CREATE = `${ADMIN_MANAGE_PERMISSIONS}create/`;
export const ADMIN_MANAGE_CONFIGURATIONS = `${ADMIN_MANAGEMENT}configurations/`;
export const ADMIN_NEW_ACCOUNT = '/new-account/';
export const ADMIN_IMPORT_USER_JOB = `${ADMIN_NEW_ACCOUNT}import-users/`;
export const ADMIN_USER_JOB_LIST = `${ADMIN_NEW_ACCOUNT}import-history/`;
